/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Spinner/theme';

export const SpinnerTheme = theme;
